
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerSections = [
    {
      title: 'Protocol',
      links: [
        { label: 'Whitepaper', href: '/whitepaper' },
        { label: 'Roadmap', href: '/roadmap' },
        { label: 'Governance', href: '/governance' }
      ]
    },
    {
      title: 'Developers',
      links: [
        { label: 'Docs', href: '/docs' },
        { label: 'SDK', href: '/sdk' },
        { label: 'API', href: '/api' }
      ]
    },
    {
      title: 'Community',
      links: [
        { label: 'Discord', href: 'https://discord.com' },
        { label: 'GitHub', href: 'https://github.com' },
        { label: 'Twitter', href: 'https://x.com/Titron_TRN' }
      ]
    },
    {
      title: 'Company',
      links: [
        { label: 'About', href: '/about' },
        { label: 'Careers', href: '/careers' },
        { label: 'Contact', href: '/contact' }
      ]
    }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* Logo and Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-6">
              <img src="/images-optimized/Logo.webp" alt="Titron Logo" className="h-12 w-auto object-contain" />
              <span className="font-bold text-2xl text-white">Titron</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Empowering verifiable data ownership with zero-knowledge proofs and modern cryptography so data can be used securely while remaining private.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://x.com/Titron_TRN"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <i className="fab fa-twitter text-lg"></i>
              </a>
              <a
                href="https://github.com/annaufdga"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <i className="fab fa-github text-lg"></i>
              </a>
              <a
                href="https://discord.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <i className="fab fa-discord text-lg"></i>
              </a>
              <a
                href="https://telegram.org"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <i className="fab fa-telegram text-lg"></i>
              </a>
            </div>
          </div>

          {/* Footer Links */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 className="font-bold text-white mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.href.startsWith('http') ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter Subscription */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8 mb-6 sm:mb-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 sm:gap-6">
            <div className="flex-1">
              <h3 className="font-bold text-lg sm:text-xl text-white mb-1 sm:mb-2">Subscribe to our newsletter</h3>
              <p className="text-gray-400 text-xs sm:text-sm">Get updates about the protocol, releases and technical progress.</p>
            </div>
            <div className="flex w-full lg:w-auto lg:max-w-md">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-3 sm:px-4 py-2 sm:py-3 bg-gray-800 border border-gray-700 rounded-l-lg focus:outline-none focus:border-teal-500 text-white placeholder-gray-400 text-sm sm:text-base"
              />
              <button className="px-4 sm:px-6 py-2 sm:py-3 bg-teal-600 hover:bg-teal-700 text-white rounded-r-lg transition-colors font-medium text-sm sm:text-base whitespace-nowrap">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">© 2020–2025 Titron. All rights reserved.</p>
            <div className="flex items-center space-x-6">
              <Link
                to="/privacy-policy"
                className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
              >
                Terms of Service
              </Link>
              <Link
                to="/cookie-settings"
                className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
              >
                Cookie Settings
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
